import { Dialog, DialogActions, DialogContent, Divider, Grid } from '@material-ui/core';
import React from 'react';
import { FaUserNurse } from 'react-icons/all';
import { SceltaMedicoResponseDTO } from '../common/Dtos';
import { SDialogButton, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import { dateTableFormat } from '../common/DateUtils';

interface InserimentoPrestazioneDialogProps {
	open: boolean;
	onClose: () => void;
	sceltaResponse: SceltaMedicoResponseDTO;
}

export function SceltaMedicoRecapDialog(props: InserimentoPrestazioneDialogProps) {
	const {onClose, open, sceltaResponse} = props;

	const handleClose = () => {
		onClose();
	}

	const formatDate = (date: string) => {
		if (date && date !== '' && date.length >= 10) {
			return dateTableFormat(date.substr(0, 10));
		}
		return '';
	}

	return (
		<Dialog
			open={open}>
			<DialogContent>
				<STitleContainer className="mt-0">
					<STitleH3>Riepilogo scelta</STitleH3>
				</STitleContainer>
				<div className="alert alert-success" role="alert">
					Operazione scelta medico eseguita con successo.
				</div>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12} className="pr-2">
						<p className="font-weight-bold mb-1 d-flex align-items-center">
							<FaUserNurse className="mr-2"/> Medico scelto
						</p>
						<p className="text-muted">
							{sceltaResponse.scelta_corrente && sceltaResponse.scelta_corrente.incarico &&
								sceltaResponse.scelta_corrente.incarico.cognome + ' ' + sceltaResponse.scelta_corrente.incarico.nome
								+ ' (cod. reg. ' + sceltaResponse.scelta_corrente.incarico.codice_regionale + ')'}
						</p>
						<p className="font-weight-bold mb-1">
							Scelto dal
						</p>
						<p className="text-muted">
							{sceltaResponse.scelta_corrente &&
							sceltaResponse.scelta_corrente.data_inizio ? formatDate(sceltaResponse.scelta_corrente.data_inizio)
								: <span className="font-italic">Informazione non presente</span>}
						</p>
						<p className="font-weight-bold mb-1">
							al
						</p>
						<p className="text-muted">
							{sceltaResponse.scelta_corrente &&
							sceltaResponse.scelta_corrente.data_fine ? formatDate(sceltaResponse.scelta_corrente.data_fine)
								: <span className="font-italic">Informazione non presente</span>}
						</p>
					</Grid>
				</Grid>
				<Divider/>
				<Grid container spacing={0} className="w-100 mt-3">
					<Grid item xs={12} className="pr-2">
						<p className="font-weight-bold mb-1 d-flex align-items-center">
							<FaUserNurse className="mr-2"/> Medico revocato
						</p>
						<p className="text-muted">
							{sceltaResponse.scelta_chiusura && sceltaResponse.scelta_chiusura.incarico &&
								sceltaResponse.scelta_chiusura.incarico.cognome + ' ' + sceltaResponse.scelta_chiusura.incarico.nome
								+ ' (cod. reg. ' + sceltaResponse.scelta_chiusura.incarico.codice_regionale + ')'}
						</p>
						<p className="font-weight-bold mb-1">
							Scelto dal
						</p>
						<p className="text-muted">
							{sceltaResponse.scelta_chiusura &&
								sceltaResponse.scelta_chiusura.data_inizio ? formatDate(sceltaResponse.scelta_chiusura.data_inizio)
								: <span className="font-italic">Informazione non presente</span>}
						</p>
						<p className="font-weight-bold mb-1">
							al
						</p>
						<p className="text-muted">
							{sceltaResponse.scelta_chiusura &&
							sceltaResponse.scelta_chiusura.data_fine ? formatDate(sceltaResponse.scelta_chiusura.data_fine)
								: <span className="font-italic">Informazione non presente</span>}
						</p>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleClose}>OK</SDialogButton>
			</DialogActions>
		</Dialog>
	)
}
